import { CatHeading } from '@blocks-react/components/Heading';
import { CVATableCellContentProps } from '../../types';
import { CatIconMinus } from '@blocks-react/components/Icons/Minus';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import styles from '../../CustomerValueAgreements.module.scss';
export const CVATableCellContent = ({
  label,
  showTooltip = false,
  ...contentProps
}: Readonly<CVATableCellContentProps>) => {
  return showTooltip ? (
    <CatTooltip position="auto">
      <CatHeading {...contentProps} slot="trigger">
        <span className={styles['cva-modal-wrapper--table-type']}>{label}</span>
      </CatHeading>
      <CatHeading {...contentProps}>{label ?? <CatIconMinus />}</CatHeading>
    </CatTooltip>
  ) : (
    <CatHeading {...contentProps}>{label ?? <CatIconMinus />}</CatHeading>
  );
};
